/* Scentzi storefront behaviour on Shopify: header, panels, bag (Cart AJAX API), search,
   favourites, tabs and the home film. Plain JS, no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const cfg = window.Scentzi || {};
  const routes = cfg.routes || {};
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- panels (search, bag, favourites, menu) ---------- */
  let openPanel = null, returnFocus = null;
  const overlay = () => $('[data-panel-overlay]');
  function open(name) {
    const panel = $(`[data-panel="${name}"]`);
    if (!panel) return;
    if (openPanel && openPanel !== panel) openPanel.hidden = true;
    closeFlyout();
    returnFocus = returnFocus || document.activeElement;
    overlay().hidden = false; panel.hidden = false; openPanel = panel;
    document.body.classList.add('sz-locked');
    ($('[data-dialog-focus]', panel) || panel).focus();
    if (name === 'favorites') renderFavorites();
    if (name === 'film') { const v = $('[data-film-player]'); if (v) v.play().catch(() => {}); }
    syncHeaderLight();
  }
  function close() {
    if (!openPanel) return;
    const film = openPanel.querySelector('[data-film-player]'); if (film) film.pause();
    openPanel.hidden = true; overlay().hidden = true; openPanel = null;
    document.body.classList.remove('sz-locked');
    if (returnFocus && returnFocus.focus) returnFocus.focus();
    returnFocus = null;
    syncHeaderLight();
  }
  cfg.openPanel = open;
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-panel]');
    if (opener) { e.preventDefault(); returnFocus = opener; open(opener.dataset.openPanel); return; }
    if (e.target.closest('[data-close-panel]') || e.target.matches('[data-panel-overlay]')) close();
    if (e.target.closest('[data-open-favorites]')) { e.preventDefault(); open('favorites'); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (openPanel) { e.preventDefault(); close(); }
    else if (activeFlyout) { const t = activeFlyout; closeFlyout(); const b = $(`#nav-${t}`); if (b) b.focus(); }
  });
  document.addEventListener('focusin', (e) => {
    if (openPanel && !openPanel.contains(e.target)) ($('[data-dialog-focus]', openPanel) || openPanel).focus();
  });

  /* ---------- header: flyouts, compact state, light over the hero ---------- */
  const header = $('[data-header]');
  let activeFlyout = null;
  function closeFlyout() {
    if (!activeFlyout) return;
    const f = header && $('#scentzi-flyout', header); if (f) f.remove();
    const b = $(`#nav-${activeFlyout}`); if (b) b.setAttribute('aria-expanded', 'false');
    activeFlyout = null; syncHeaderLight();
  }
  function openFlyout(name) {
    closeFlyout();
    const tpl = $(`template[data-flyout-template="${name}"]`);
    if (!tpl || !header) return;
    header.appendChild(tpl.content.cloneNode(true));
    const trigger = $(`#nav-${name}`);
    trigger.setAttribute('aria-expanded', 'true'); trigger.setAttribute('aria-controls', 'scentzi-flyout');
    activeFlyout = name; syncHeaderLight();
  }
  $$('[data-flyout]').forEach((btn) => {
    btn.addEventListener('click', () => (activeFlyout === btn.dataset.flyout ? closeFlyout() : openFlyout(btn.dataset.flyout)));
    btn.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault(); openFlyout(btn.dataset.flyout);
      requestAnimationFrame(() => { const a = $('#scentzi-flyout a', header); if (a) a.focus(); });
    });
  });
  document.addEventListener('pointerdown', (e) => { if (activeFlyout && header && !header.contains(e.target)) closeFlyout(); });
  if (header) header.addEventListener('focusout', (e) => { if (activeFlyout && !header.contains(e.relatedTarget)) closeFlyout(); });
  addEventListener('resize', () => { if (activeFlyout && innerWidth < 1100) closeFlyout(); });

  const hero = $('.hero-shell');
  function syncHeaderLight() {
    if (!header) return;
    const bar = $('header', header);
    // See-through while the film plays under the header; once it is over, the homepage gets the same light
    // header as every other page (owner, 31 October 2026). Not with the white-homepage setting.
    const overHero = !!hero && hero.getBoundingClientRect().bottom > (header.offsetHeight || (bar && bar.offsetHeight) || 100);
    const light = overHero && !activeFlyout && !openPanel && !header.hasAttribute('data-header-solid');
    header.classList.toggle('is-over-hero', light);
    // Cream wordmark only over the dark film; the dark one on light backgrounds (as React).
    const mark = $('.wordmark-main', header);
    if (mark) { const want = light ? mark.dataset.srcLight : mark.dataset.srcDark; if (want && mark.getAttribute('src') !== want) mark.src = want; }
  }
  // Nothing from the film slides through the see-through header (owner, 2 November 2026): the category
  // circles at the top (allowed 40 px under it) and the closing text at the end fade out over 40 px as they
  // reach it. Under the light header content simply scrolls away, as on every other page.
  const fadeUnder = [...$$('.szc-over').map((el) => [el, 40]), ...$$('.hero-closing > p, .hero-closing-actions').map((el) => [el, 0])];
  function fadeBelowHeader() {
    if (!header || !fadeUnder.length) return;
    const edge = header.getBoundingClientRect().bottom, over = header.classList.contains('is-over-hero');
    fadeUnder.forEach(([el, lead]) => {
      const o = over ? Math.min(1, Math.max(0, (el.getBoundingClientRect().top - edge + lead) / 40)) : 1;
      el.style.opacity = o < 1 ? o.toFixed(2) : '';
      el.style.visibility = o === 0 ? 'hidden' : '';
    });
  }
  const syncCompact = () => header && header.classList.toggle('is-compact', scrollY > 40);
  // Product pages on desktop (owner, 2 November 2026, like The Essence Vault): the menu tucks away while scrolling
  // down so the sticky product photo is never covered, and comes back on any scroll up or keyboard focus.
  const tuckable = header && $('.pdpx-gallery') && matchMedia('(min-width: 1100px)');
  let tuckY = scrollY;
  function syncTuck() {
    if (!tuckable) return;
    const y = scrollY, d = y - tuckY;
    if (!tuckable.matches || y < 300) header.classList.remove('is-tucked');
    else if (d > 6) header.classList.add('is-tucked');
    else if (d < -6) header.classList.remove('is-tucked');
    if (Math.abs(d) > 6 || y < 300) tuckY = y;
  }
  if (tuckable) header.addEventListener('focusin', () => header.classList.remove('is-tucked'));
  addEventListener('scroll', () => { syncCompact(); syncTuck(); syncHeaderLight(); fadeBelowHeader(); }, { passive: true });
  addEventListener('resize', () => { syncHeaderLight(); fadeBelowHeader(); });
  syncCompact(); syncHeaderLight(); fadeBelowHeader();

  $$('[data-mobile-toggle]').forEach((btn) => btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    $$('[data-mobile-toggle]').forEach((other) => {
      other.setAttribute('aria-expanded', 'false'); other.lastElementChild.textContent = '+';
      document.getElementById(other.getAttribute('aria-controls')).hidden = true;
    });
    if (expanded) return;
    btn.setAttribute('aria-expanded', 'true'); btn.lastElementChild.textContent = '−';
    document.getElementById(btn.getAttribute('aria-controls')).hidden = false;
  }));

  /* ---------- bag (Shopify Cart AJAX API + Section Rendering) ---------- */
  // Same notation as Liquid's money filter (shop setting), e.g. "€{{amount_with_comma_separator}}".
  const money = (cents) => {
    const amount = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    const fmt = cfg.moneyFormat || '€ {{amount_with_comma_separator}}';
    return fmt.replace(/\{\{\s*amount\w*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
  };
  cfg.money = money;
  function applyCart(sections, count) {
    const html = sections && sections['cart-drawer'];
    if (html) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
      const body = $('[data-bag-body] [data-cart-drawer]');
      if (fresh && body) body.replaceWith(fresh);
      if (count === undefined && fresh) count = +fresh.dataset.itemCount;
    }
    if (count !== undefined) {
      $$('[data-bag-count]').forEach((el) => { el.textContent = count; });
      $$('[data-bag-button]').forEach((el) => el.setAttribute('aria-label', `Winkeltas, ${count} producten`));
    }
    document.dispatchEvent(new CustomEvent('scentzi:cart', { detail: { count } }));
  }
  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: 'cart-drawer', sections_url: location.pathname })),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Er ging iets mis');
    return data;
  }
  async function addItems(items, button) {
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      const data = await cartRequest(routes.cartAdd + '.js', { items });
      applyCart(data.sections);
      open('bag');
      return true;
    } catch (err) {
      const box = button && button.closest('form, .ab-purchase-panel');
      const slot = box && $('.ab-error', box);
      if (slot) slot.textContent = err.message; else alert(err.message);
      return false;
    } finally { if (button) button.removeAttribute('aria-busy'); }
  }
  cfg.addItems = addItems;

  // Gift ladder guard (gifts are EUR 0 products added by sz-pdpx.js): drop a gift once the bag no longer
  // reaches its tier, e.g. after a perfume is removed, and keep no more of each than the tiers reached.
  // Tiers match data-tiers: samples with free shipping at EUR 70, care at EUR 115; the 30 ml gift is gone.
  const GIFT_TIERS = { 'cadeau-3-samples': [7000], 'cadeau-verzorging': [11500], 'cadeau-30ml': [] };
  let guarding = false;
  async function guardGifts() {
    if (guarding) return;
    guarding = true;
    try {
      const cart = await (await fetch(`${routes.cart || '/cart'}.js`)).json();
      const updates = {};
      const kept = {};
      cart.items.forEach((item) => {
        const tiers = GIFT_TIERS[item.handle];
        if (!tiers) return;
        const room = tiers.filter((t) => cart.total_price >= t).length - (kept[item.handle] || 0);
        const keep = Math.max(0, Math.min(item.quantity, room));
        if (keep !== item.quantity) updates[item.key] = keep;
        kept[item.handle] = (kept[item.handle] || 0) + keep;
      });
      if (Object.keys(updates).length) {
        const data = await cartRequest(`${routes.cart || '/cart'}/update.js`, { updates });
        applyCart(data.sections, data.item_count);
      }
    } catch (_) { /* the bag still works; checkout shows the real lines */ } finally { guarding = false; }
  }
  document.addEventListener('scentzi:cart', guardGifts);
  if ($$('[data-bag-count]').some((el) => +el.textContent > 0)) guardGifts();
  document.addEventListener('click', async (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); returnFocus = quick; addItems([{ id: +quick.dataset.quickAdd, quantity: 1 }], quick); return; }
    const line = e.target.closest('[data-bag-body] [data-line]');
    if (!line) return;
    e.preventDefault(); line.setAttribute('aria-busy', 'true');
    try {
      const data = await cartRequest(routes.cartChange + '.js', { line: +line.dataset.line, quantity: +line.dataset.quantity });
      applyCart(data.sections, data.item_count);
    } catch (err) { alert(err.message); }
  });

  /* ---------- predictive search ---------- */
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  const clearBtn = $('[data-search-clear]');
  const emptySearch = searchResults ? searchResults.innerHTML : '';
  let searchTimer, searchController;
  if (searchInput) searchInput.addEventListener('input', () => {
    const q = searchInput.value.trim();
    clearBtn.hidden = !q;
    clearTimeout(searchTimer);
    if (!q) { searchResults.innerHTML = emptySearch; return; }
    searchTimer = setTimeout(async () => {
      if (searchController) searchController.abort();
      searchController = new AbortController();
      try {
        const url = `${routes.search}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.sku,vendor,tag,body&section_id=predictive-search`;
        const html = await (await fetch(url, { signal: searchController.signal })).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-results]');
        if (fresh) searchResults.replaceChildren(fresh);
      } catch (err) { if (err.name !== 'AbortError') console.warn(err); }
    }, 180);
  });
  if (clearBtn) clearBtn.addEventListener('click', () => { searchInput.value = ''; searchInput.dispatchEvent(new Event('input')); searchInput.focus(); });

  /* ---------- favourites (this browser only, like the React build) ---------- */
  const FAV_KEY = 'scentzi-favorites';
  const readFavs = () => { try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (_) { return []; } };
  const writeFavs = (list) => { try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (_) { /* private mode */ } };
  const HEART = 'M178,40c-20.65,0-38.73,8.88-50,23.89C116.73,48.88,98.65,40,78,40a62.07,62.07,0,0,0-62,62c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,228.66,240,172,240,102A62.07,62.07,0,0,0,178,40ZM128,214.8C109.74,204.16,32,155.69,32,102A46.06,46.06,0,0,1,78,56c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,155.61,146.24,204.15,128,214.8Z';
  const HEART_FILL = 'M240,102c0,70-103.79,126.66-108.21,129a8,8,0,0,1-7.58,0C119.79,228.66,16,172,16,102A62.07,62.07,0,0,1,78,40c20.65,0,38.73,8.88,50,23.89C139.27,48.88,157.35,40,178,40A62.07,62.07,0,0,1,240,102Z';
  function syncFavButtons() {
    const favs = readFavs();
    $$('[data-favorite]').forEach((btn) => {
      const on = favs.includes(btn.dataset.favorite);
      btn.setAttribute('aria-pressed', on);
      btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace(/^(Bewaar|Verwijder) (.*) (in|uit) favorieten$/, `${on ? 'Verwijder' : 'Bewaar'} $2 ${on ? 'uit' : 'in'} favorieten`));
      const path = btn.querySelector('svg path');
      if (path) path.setAttribute('d', on ? HEART_FILL : HEART);
    });
    $$('[data-favorite-count]').forEach((el) => { el.textContent = favs.length; });
  }
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  async function renderFavorites() {
    const list = $('[data-favorites-list]'), empty = $('[data-favorites-empty]');
    const favs = readFavs();
    empty.hidden = favs.length > 0;
    const root = (routes.root || '/').replace(/\/$/, '');
    const items = await Promise.all(favs.map((h) => fetch(`${root}/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
    list.innerHTML = items.filter(Boolean).map((p) => {
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const img = p.featured_image ? `<img src="${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=144" alt="${escapeHtml(p.title)}" width="72" height="112" loading="lazy">` : '';
      return `<div class="mini-product"><a class="mini-image" href="${p.url}">${img}</a><div><span class="mini-brand">${escapeHtml(p.vendor)}</span><a href="${p.url}"><h3>${escapeHtml(p.title)}</h3></a><p>${money(v.price)} · ${escapeHtml(v.title)}</p><div class="favorite-actions"><button class="inline-link" type="button" data-quick-add="${v.id}">Toevoegen aan tas</button><button class="icon-button" type="button" aria-label="Verwijder ${escapeHtml(p.title)} uit favorieten" aria-pressed="true" data-favorite="${p.handle}"><svg width="18" height="18" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="${HEART_FILL}"></path></svg></button></div></div></div>`;
    }).join('');
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-favorite]');
    if (!btn) return;
    e.preventDefault();
    const favs = readFavs(), h = btn.dataset.favorite;
    writeFavs(favs.includes(h) ? favs.filter((x) => x !== h) : favs.concat(h));
    syncFavButtons();
    if (btn.closest('[data-favorites-list]')) renderFavorites();
  });
  syncFavButtons();

  /* ---------- tabs (home shelf and product page) ---------- */
  $$('[role=tablist]').forEach((list) => {
    const tabs = $$('[role=tab]', list);
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on); t.dataset.state = on ? 'active' : 'inactive'; t.tabIndex = on ? 0 : -1;
        if (panel) { panel.dataset.state = on ? 'active' : 'inactive'; panel.hidden = !on; }
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
  });

  /* ---------- sticky "Vind mijn geur" on the mobile home page ---------- */
  const sticky = $('[data-sticky-finder]'), footer = $('.site-footer');
  if (sticky && hero && footer) {
    let pastHero = false, nearFooter = false;
    const sync = () => {
      const v = pastHero && !nearFooter;
      sticky.dataset.visible = v; sticky.setAttribute('aria-hidden', !v); sticky.querySelector('a').tabIndex = v ? 0 : -1;
    };
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(hero);
    new IntersectionObserver(([e]) => { nearFooter = e.isIntersecting; sync(); }, { rootMargin: '0px 0px 120px 0px' }).observe(footer);
  }

  /* ---------- scroll films (home hero, perfume scent journey): scroll scrubs one hosted video ---------- */
  function setupScrub(scrub, onProgress) {
    const video = $('video', scrub);
    if (!video || reduceMotion) return null;
    const mobile = matchMedia('(hover: none) and (pointer: coarse), (max-width: 860px)').matches;
    const src = mobile ? video.dataset.srcMobile : video.dataset.srcDesktop;
    const layer = video.closest('[data-scroll-scrub-layer]');
    let target = 0, ready = false, raf = 0, started = false, active = true;
    const progress = () => {
      const r = scrub.getBoundingClientRect();
      const total = r.height - innerHeight;
      return Math.min(1, Math.max(0, total > 0 ? -r.top / total : 0));
    };
    const tick = () => {
      raf = 0;
      if (!active) return;
      const p = progress();
      scrub.style.setProperty('--ss-progress', p.toFixed(4));
      if (onProgress) onProgress(p);
      if (ready && video.duration) {
        target = p * (video.duration - 0.05);
        if (Math.abs(video.currentTime - target) > 0.015 && !video.seeking) video.currentTime = target;
      }
    };
    // iOS Safari only decodes and paints seeked frames after the video has played once, and with
    // preload="none" it never fires loadeddata on its own. So: preload, and prime (muted play + pause)
    // as soon as there is data and again on the first touch, as the React scroll-scrub engine does.
    video.muted = true; video.playsInline = true; video.setAttribute('muted', ''); video.setAttribute('playsinline', '');
    let primed = false;
    const prime = () => {
      if (primed || !video.getAttribute('src')) return;
      const p = video.play();
      if (p && p.then) p.then(() => { primed = true; video.pause(); tick(); }).catch(() => {}); else { primed = true; video.pause(); }
    };
    const markReady = () => { if (ready) return; ready = true; prime(); tick(); };
    const load = async () => {
      started = true;
      video.preload = 'auto';
      video.addEventListener('loadedmetadata', markReady, { once: true });
      video.addEventListener('loadeddata', markReady, { once: true });
      video.addEventListener('seeked', () => { layer.dataset.videoPainted = 'true'; }, { once: true });
      try { video.src = URL.createObjectURL(await (await fetch(src)).blob()); } catch (_) { video.src = src; }
      // Some WebKit builds refuse a blob: video; fall back to the file itself once.
      video.addEventListener('error', () => {
        if (!video.src.startsWith('blob:')) return;
        URL.revokeObjectURL(video.src); video.src = src; video.load(); prime();
      });
      video.load();
      prime(); // muted playback is allowed without a gesture and makes iOS load the data
    };
    const onGesture = () => { if (started) prime(); };
    addEventListener('touchstart', onGesture, { once: true, passive: true });
    addEventListener('pointerdown', onGesture, { once: true, passive: true });
    video.addEventListener('seeked', () => { if (Math.abs(video.currentTime - target) > 0.03) video.currentTime = target; });
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
    new IntersectionObserver(([e]) => { if (e.isIntersecting && !started) load(); }, { rootMargin: '400px' }).observe(scrub);
    tick();
    return { setActive: (on) => { active = on; if (on) tick(); } };
  }
  const heroScrub = $('.hero-shell [data-scrub]');
  if (heroScrub) {
    // Scene boundaries of the film (React filmChapters): drive the captions (Geurnoten, Thuis,
    // Onderweg) and the closing text through data-scene, as on the React homepage.
    const heroShell = heroScrub.closest('.hero-shell');
    const chapters = [0, 0.26, 0.49, 0.66, 0.89];
    const setScene = (p) => {
      const scene = chapters.reduce((found, from, i) => (p >= from ? i : found), 0);
      if (heroShell && heroShell.dataset.scene !== String(scene)) heroShell.dataset.scene = String(scene);
    };
    if (!setupScrub(heroScrub, setScene)) {
      const onScroll = () => {
        const r = heroScrub.getBoundingClientRect(), total = r.height - innerHeight;
        setScene(Math.min(1, Math.max(0, total > 0 ? -r.top / total : 0)));
      };
      addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  }

  const journey = $('[data-journey]');
  if (journey) {
    const film = $('[data-journey-film]', journey);
    const beats = JSON.parse(document.querySelector('[data-journey-beats]').textContent);
    const live = $('[data-live-text]', journey);
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    const arrow = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true"><path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path></svg>';
    const beatHtml = (b, i) => `<span class="aj-kicker">${esc(b.kicker)}</span><h3>${esc(b.title)}</h3><p>${esc(b.body)}</p><ul class="aj-live-notes">${b.notes.map((n) => `<li>${esc(n)}</li>`).join('')}</ul>${i === 3 ? `<a href="#abyss-kiezen" class="aj-return"><span>Kies jouw formaat</span>${arrow}</a>` : ''}`;
    let current = -1;
    const show = (i) => {
      if (i === current) return;
      current = i;
      journey.dataset.journeyChapter = i;
      live.dataset.visibleBeat = beats[i].key;
      live.innerHTML = beatHtml(beats[i], i);
      $$('[data-beat]', journey).forEach((b) => { if (+b.dataset.beat === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
    };
    const beatAt = (p) => beats.reduce((idx, b, i) => (p >= b.at ? i : idx), 0);
    show(0);
    // Static view: the four beats as articles (also used with reduced motion).
    $$('[data-static-beat]', journey).forEach((art) => {
      const b = beats[+art.dataset.staticBeat];
      art.lastElementChild.innerHTML = `<span class="ab-eyebrow">${esc(b.kicker)}</span><h3>${esc(b.title)}</h3><p>${esc(b.body)}</p><div class="ab-note-list">${b.notes.map((n) => `<span>${esc(n)}</span>`).join('')}</div>`;
    });
    const staticBox = $('[data-journey-static]', journey), toggle = $('[data-journey-toggle]', journey);
    const scrubber = setupScrub(film, (p) => show(beatAt(p)));
    const setStill = (still) => {
      journey.dataset.journeyMode = still ? 'still' : 'scroll';
      film.hidden = still; staticBox.hidden = !still;
      toggle.textContent = reduceMotion ? 'Minder beweging actief' : still ? 'Bekijk met scrollbeweging' : 'Stilstaande weergave';
      if (scrubber) scrubber.setActive(!still);
    };
    if (reduceMotion) { toggle.disabled = true; setStill(true); }
    toggle.addEventListener('click', () => { setStill(journey.dataset.journeyMode !== 'still'); journey.scrollIntoView({ block: 'start' }); });
    $$('[data-beat]', journey).forEach((btn) => btn.addEventListener('click', () => {
      const i = +btn.dataset.beat, r = film.getBoundingClientRect();
      const stage = $('.scroll-scrub__stage', film);
      const top = parseFloat(getComputedStyle(stage).top) || 0;
      const fraction = Math.min(0.985, beats[i].at + 0.035);
      scrollTo({ top: scrollY + r.top - top + Math.max(1, r.height - stage.getBoundingClientRect().height) * fraction, behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
    const header = $('.header-stack');
    const syncHeader = () => journey.style.setProperty('--aj-header', `${header ? header.getBoundingClientRect().height : 0}px`);
    syncHeader(); addEventListener('resize', syncHeader);
  }

  /* initial state for tab lists whose markup came without data-state (product page "Meer ontdekken") */
  $$('[role=tablist]').forEach((list) => {
    const tabs = $$('[role=tab]', list);
    const active = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];
    tabs.forEach((t) => {
      const on = t === active, panel = document.getElementById(t.getAttribute('aria-controls'));
      t.dataset.state = on ? 'active' : 'inactive'; t.tabIndex = on ? 0 : -1;
      if (panel) { panel.dataset.state = on ? 'active' : 'inactive'; panel.hidden = !on; }
    });
  });
})();
